var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgOptionChecked = function SvgOptionChecked(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.99909,
    y: 1.99912,
    width: 20.0018,
    height: 20.0018,
    rx: 10.0009,
    fill: "#054BC7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.6152L10.0125 15.6277L16.64 9.00015",
    stroke: "white",
    strokeWidth: 1.50136,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.99909,
    y: 1.99912,
    width: 20.0018,
    height: 20.0018,
    rx: 10.0009,
    stroke: "#054BC7",
    strokeWidth: 2.00182
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgOptionChecked);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMS45OTkwOSIgeT0iMS45OTkxMiIgd2lkdGg9IjIwLjAwMTgiIGhlaWdodD0iMjAuMDAxOCIgcng9IjEwLjAwMDkiIGZpbGw9IiMwNTRCQzciLz4KPHBhdGggZD0iTTcgMTIuNjE1MkwxMC4wMTI1IDE1LjYyNzdMMTYuNjQgOS4wMDAxNSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUwMTM2IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHJlY3QgeD0iMS45OTkwOSIgeT0iMS45OTkxMiIgd2lkdGg9IjIwLjAwMTgiIGhlaWdodD0iMjAuMDAxOCIgcng9IjEwLjAwMDkiIHN0cm9rZT0iIzA1NEJDNyIgc3Ryb2tlLXdpZHRoPSIyLjAwMTgyIi8+Cjwvc3ZnPgo=";